import { Theme } from '@mui/material';

export const googleMapWrapper = {
	margin: { md: '1.5rem 1.5rem 0 0' },
};

export const getGoogleMapStyles = ({
	isSmallScreen,
	theme,
	hasSingleComingSoonFacility,
}: {
	theme: Theme;
	isSmallScreen?: boolean;
	hasSingleComingSoonFacility?: boolean;
}) => {
	const smallScreenHeight = hasSingleComingSoonFacility ? '18.75rem' : 'calc(100vh - 12.5rem)';
	return {
		height: isSmallScreen ? smallScreenHeight : '100%',
		borderRadius: isSmallScreen ? '0' : '1rem',
		border: isSmallScreen ? 'none' : '0.0625rem solid',
		borderColor: isSmallScreen ? 'none' : theme.palette.neutrals?.primary,
		overflow: 'hidden',
	};
};
